<template>
  <div>
  <div class="container">
    <div class="col-lg-12 pd-top-15" v-if="crumbs.length > 1">
      <span class="backText" @click="navigate(crumbs[crumbs.length-1],crumbs.length-2)"> <i class="fa fa-angle-left"></i> {{ $t("message.front_page.back_btn") }}</span>
    </div>
    <div class="col-lg-12" v-bind:class="[{'pd-top-15': (crumbs.length > 1)},{'pd-top-30': !(crumbs.length > 1)}]">
      <div v-if="acceptFlag==0" class="userResponseHolder">
        <span class="acceptRejectText">{{ $t("message.accept_reject_popup.accept_reject_message") }}</span>
        <div class="acceptRejectBtns">
          <!-- <span class="rejectBtn"> -->
            <button class="rejectBtn" @click="rejectUserTask()">{{ $t("message.accept_reject_popup.reject_btn") }}</button>
          <!-- </span> -->
          <!-- <span class="acceptBtn"> -->
            <button class="acceptBtn" @click="accept()">{{ $t("message.accept_reject_popup.accept_btn") }}</button>
          <!-- </span> -->
        </div>
      </div>
      <div v-else>
        <span class="folderTxtHolder">
          <div class="filesAndFoldersTxt">{{ $t("message.accept_reject_popup.start_activity_btn") }}</div>
          <div v-if="crumbs.length > 1" class="foldersTxt">{{crumbs[crumbs.length-1].displayName}}</div>
        </span>
        <span v-if="crumbs.length <= 1" class="fltRight"><button class="completeTask" @click="completeButtonClick()">{{ $t("message.front_page.complete_btn") }}</button></span>
        <!-- <span v-else>
          <span class="downloadHolder" @click="downloadAllFiles">
            <span class="drpAllImgSvg downloadIcon" v-bind:class="[{'enable': (this.selectedFiles.length > 0)}]"></span>
            <span class="txtDownload" v-bind:class="[{'enable': (this.selectedFiles.length > 0)}]" > {{ $t("message.front_page.download_btn") }}</span>
          </span>
        </span> -->
      </div>
    </div>
  </div>

  <div class="container">
    <div class="col-lg-12 pd-top-40">
      <div class="headerList">
        <span class="wd35">{{ $t("message.front_page.filename") }}</span>
        <span class="wd20">{{ $t("message.front_page.size") }}</span>
        <span class="wd20">{{ $t("message.front_page.date_uploaded") }}</span>

        <span class="downloadHolder" @click="downloadAllFiles">
          <span class="drpAllImgSvg downloadIcon" v-bind:class="[{'enable': (this.selectedFiles.length > 0)}]"></span>
          <span class="txtDownload" v-bind:class="[{'enable': (this.selectedFiles.length > 0)}]" > {{ $t("message.front_page.download_btn") }}</span>
        </span>


      </div>
      <div class="filesAndFoldersList"  v-for="file in files">
        <div class="rowholder cursPointer" @click="toggle(file)" v-bind:class="[{'selected': file.ischeck}]">   
          <span class="wd35">
            <input type="checkbox" style="width: 19px; height: 19px;" v-if="file.isfolder" v-model="file.ischeck" @click="folderselect(file)" @click.stop />
            <span class="folderImg drpAllImgSvg" v-if="file.isfolder"></span>
            <span v-else class="drpAllImgSvg" v-bind:class="[{'tickImg': file.ischeck},{'checkImg': !file.ischeck}]"></span>
            <span class="nameHolderText">{{file.filename}}</span>
          </span>
          <span class="wd20 sizeHolderText">{{file.size}}</span>
          <span class="wd20">
            <span class="dateHolderText">{{file.lastmodified.substr(0,file.lastmodified.indexOf(' '))}}</span>
            <span class="timeHolderText">{{file.lastmodified.substr(file.lastmodified.indexOf(' ')+1)}}</span>
          </span>
          <span v-if="file.isfolder" class="wd15"></span>
          <span v-else class="wd15 downloadText" @click.stop="" @click="downloadFromRow(file)"><span>{{ $t("message.front_page.download_btn") }}</span></span>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import JSZip from 'jszip'
  import JSZipUtils from 'jszip-utils'
  import FileSaver from 'file-saver'
  import Vue from 'vue'
  import DynamicUiForm from '../../components/dropzone/DynamicUiForm.vue'
  import VuejsDialog from 'vuejs-dialog'
  Vue.use(VuejsDialog)
  
  import {ERROR_MSG, DOWNLOADING, DOWNLOADING_SUCCESS, NOTIFY, NOTIFY_SUCCESS} from '../../store/mutation-types'

  var zip = new JSZip()
  var zipname
  export default {
    data () {
      return {
        files: [],
        downloadAll: false,
        rejectReason: '',
        selectedFiles: [],
        taskDecisionFlag: false,
        acceptFlag: 1,
        model: {
          'dynamicUiData': [],
          'dynamicMetadataPopupFlag': false,
          'acceptRejectFlag': true,
          'form': {

          },
          'errorMsg': {

          }
        },
        crumbs: []
      }
    },
    computed: {
    },
    created () {
      this.taskDecisionFlag = this.$store.getters.getUserTaskDecision
      console.log('View files:' + this.$store.getters.getUserDetails)
      this.crumbs.push({displayName: 'Home', path: ''})
      var payload = { sessionid: this.$store.getters.getUserDetails }
      this.$store.dispatch('allFiles', payload).then(function () {
        // TODO: allFiles to be renamed as dropzoneconfig and files should be nested into that
        this.selectedFiles = []
        console.log(this.$store.getters.allFiles)
        if (this.$store.getters.allFiles.dropzoneConfig.delflag === 1) {
          this.$router.push({name: 'Frozen'})
        } else {
          console.log(this.$store.getters.getUserTaskDecision)
          // this.taskDecisionFlag = this.$store.getters.getUserTaskDecision
          this.files = this.$store.getters.allFiles.files
          this.acceptFlag = this.$store.getters.allFiles.dropzoneConfig.acceptflag
          console.log(this.$store.getters.allFiles.dropzoneConfig.propertydata)
          this.model.dynamicUiData = JSON.parse(this.$store.getters.allFiles.dropzoneConfig.propertydata)
          this.model.metadataid = this.$store.getters.allFiles.dropzoneConfig.metadataid
          this.model.jobflowmetadataid = this.$store.getters.allFiles.dropzoneConfig.jobflowmetadataid
          this.downloadAll = this.files.length > 0
        }
      }.bind(this))
      .catch(function () {
        this.$store.commit(ERROR_MSG, {
          type: 'error',
          title: this.$t('message.error_popup_page.error'),
          content: this.$t('message.error_popup_page.relaunch_msg')
        })
      }.bind(this))
    },
    methods: {

      accept () {
        var payload = {}
        payload.sessionid = this.$store.getters.getUserDetails
        this.$store.dispatch('updateAcceptFlagFromDropzone', payload).then(function () {
          this.acceptFlag = 1
        }.bind(this))
        .catch(function () {
          this.$store.commit(ERROR_MSG, {
            type: 'error',
            title: this.$t('message.error_popup_page.error'),
            content: this.$t('message.error_popup_page.retry_msg')
          })
        }.bind(this))
      },
      rejectUserTask () {
        var payload = {}
        payload.sessionid = this.$store.getters.getUserDetails
        payload.status = false
        this.$store.dispatch('notify', payload).then(function () {
          this.$router.push({name: 'Decline'})
        }.bind(this))
        .catch(function () {
          this.$store.commit(ERROR_MSG, {
            type: 'error',
            title: this.$t('message.error_popup_page.error'),
            content: this.$t('message.error_popup_page.retry_msg')
          })
        }.bind(this))
      },
      downloadFromRow (file) {
        console.log('Download files:' + this.$store.getters.getUserDetails)
        var currentFolderPath = this.crumbs.slice(1).map(function (crumb) { return crumb.displayName }).join('/')

        this.$store.commit(DOWNLOADING)
        var payload = { sessionid: this.$store.getters.getUserDetails, selectedFiles: [file], folder: currentFolderPath }
        console.log(payload)
        this.$store.dispatch('signedUrlForDownload', payload).then(function () {
          console.log(this.$store.getters.signedUrlForDownload)
          var signedUrls = this.$store.getters.signedUrlForDownload
          this.downloadFile(signedUrls)
        }.bind(this))
      },
      downloadAllFiles () {
        if (this.selectedFiles.length > 0) {
          console.log('Download files:' + this.$store.getters.getUserDetails)
          var currentFolderPath = this.crumbs.slice(1).map(function (crumb) { return crumb.displayName }).join('/')
          this.$store.commit(DOWNLOADING)
          var payload = { sessionid: this.$store.getters.getUserDetails, selectedFiles: this.selectedFiles, folder: currentFolderPath }
          console.log(payload)
          this.$store.dispatch('signedUrlForDownload', payload).then(function () {
            console.log(this.$store.getters.signedUrlForDownload)
            var signedUrls = this.$store.getters.signedUrlForDownload
            var requests = []
            zip = new JSZip()
            var zipFolder
            if (signedUrls.length === 1) {
              this.downloadFile(signedUrls)
            } else {
              for (var j = 0; j < signedUrls.length; j++) {
                requests.push(this.request(signedUrls[j], zipFolder, zip))
              }
              zipname = this.getZipname(signedUrls[0])
              Promise.all(requests).then(function () {
                this.prepareZip(zipname, zip)
              }.bind(this))
            }
            for (var k = 0; k < this.selectedFiles.length; j++) {
              this.toggle_downladAll(this.selectedFiles[k])
            }
          }.bind(this))
        }
      },
      downloadFile (signedUrls) {
        JSZipUtils.getBinaryContent(signedUrls[0].key, function (err, data) {
          console.log(err)
          console.log(data)
          var blob = new Blob([data], {type: 'blob'})
          FileSaver.saveAs(blob, signedUrls[0].name)
          this.$store.commit(DOWNLOADING_SUCCESS, {})
        }.bind(this))
      },
      request (urlObj, zipFolder, zip) {
        return new Promise(function (resolve) {
          JSZipUtils.getBinaryContent(urlObj.key, function (err, data) {
            console.log(err)
            var folderpath = urlObj.path
            var index = folderpath.indexOf('Article')
            if (index !== -1) {
              folderpath = folderpath.slice(index)
            } else {
              index = folderpath.indexOf('Issue')
              if (index !== -1) {
                folderpath = folderpath.slice(index)
              }
            }
            zipFolder = zip.folder(folderpath)
            zipFolder.file(urlObj.name, data, {binary: true})
            resolve()
          })
        })
      },
      getZipname (signedUrl) {
        var folderpathparts = signedUrl.path.split('/')
        var indexParts = folderpathparts.indexOf('Article')
        if (indexParts !== -1) {
          console.log(folderpathparts[indexParts])
        } else {
          indexParts = folderpathparts.indexOf('Issue')
          if (indexParts !== -1) {
            console.log(folderpathparts[indexParts])
          }
        }
        zipname = folderpathparts[indexParts + 1] + '_' + folderpathparts[indexParts + 3]
        console.log(zipname)
        console.log('+++++++++++++++++++++++')
        return zipname
      },
      prepareZip (zipname, zip) {
        zip.generateAsync({ type: 'blob' }).then(function (content) {
          FileSaver.saveAs(content, zipname + '.zip')
          this.$store.commit(DOWNLOADING_SUCCESS, {})
        }.bind(this))
      },
      toggle (file) {
        if (file.isfolder) {
          this.openFolder(file)
          return
        }
        var fileIndex = this.selectedFiles.indexOf(file)
        if (fileIndex === -1) this.selectedFiles.push(file)
        else this.selectedFiles.splice(fileIndex, 1)
        if (typeof file.ischeck === 'undefined') {
          Vue.set(file, 'ischeck', false)
        }
        if (file.ischeck) file.ischeck = false
        else file.ischeck = true
      },
      toggle_downladAll (file) {
        var fileIndex = this.selectedFiles.indexOf(file)
        if (fileIndex === -1) this.selectedFiles.push(file)
        else this.selectedFiles.splice(fileIndex, 1)
        if (typeof file.ischeck === 'undefined') {
          Vue.set(file, 'ischeck', false)
        }
        if (file.ischeck) file.ischeck = false
        else file.ischeck = true
      },
      folderselect (file) {
        var fileIndex = this.selectedFiles.indexOf(file)
        if (fileIndex === -1) this.selectedFiles.push(file)
        else this.selectedFiles.splice(fileIndex, 1)
        if (typeof file.ischeck === 'undefined') {
          Vue.set(file, 'ischeck', false)
        }
        if (file.ischeck) file.ischeck = false
        else file.ischeck = true
      },
      openFolder (file) {
        console.log('View files:' + this.$store.getters.getUserDetails)
        this.crumbs.push({displayName: file.filename, path: file.filename})

        var currentFolderPath = this.crumbs.slice(1).map(function (crumb) { return crumb.displayName }).join('/')
        console.log(currentFolderPath)

        var payload = { sessionid: this.$store.getters.getUserDetails, folder: currentFolderPath }
        this.$store.dispatch('allFiles', payload).then(function () {
          this.selectedFiles = []
          this.files = this.$store.getters.allFiles.files
          if (this.files.length > 0) this.downloadAll = true
        }.bind(this))
        .catch(function () {
          this.$store.commit(ERROR_MSG, {
            type: 'error',
            title: this.$t('message.error_popup_page.error'),
            content: this.$t('message.error_popup_page.relaunch_msg')
          })
        }.bind(this))
      },
      navigate (file, key) {
        console.log('View files:' + this.$store.getters.getUserDetails)
        this.crumbs.splice(key + 1, this.crumbs.length)

        var currentFolderPath = this.crumbs.slice(1).map(function (crumb) { return crumb.displayName }).join('/')
        var payload = { sessionid: this.$store.getters.getUserDetails }
        if (currentFolderPath !== '') { // TODO : Home hardcode to be removed.
          payload.folder = currentFolderPath
        }
        this.$store.dispatch('allFiles', payload).then(function () {
          this.selectedFiles = []
          this.files = this.$store.getters.allFiles.files
          if (this.files.length > 0) this.downloadAll = true
        }.bind(this))
        .catch(function () {
          this.$store.commit(ERROR_MSG, {
            type: 'error',
            title: this.$t('message.error_popup_page.error'),
            content: this.$t('message.error_popup_page.relaunch_msg')
          })
        }.bind(this))
      },
      notify (userStatus) {
        console.log(userStatus)
        console.log('Notify for:' + this.$store.getters.getUserDetails)
        this.$dialog.confirm('This action will freeze the dropzone url')
        .then(function () {
          console.log('clicked')
          console.log(this)
          this.$store.commit(NOTIFY)
          var payload = { sessionid: this.$store.getters.getUserDetails, status: 'accepted' }
          this.$store.dispatch('notify', payload).then(function () {
            this.$router.push({name: 'Frozen'})
            this.$store.commit(NOTIFY_SUCCESS, {})
          }.bind(this))
            .catch(function () {
              this.$store.commit(ERROR_MSG, {
                type: 'error',
                title: this.$t('message.error_popup_page.error'),
                content: this.$t('message.error_popup_page.relaunch_msg')
              })
            }.bind(this))
        }.bind(this))
      },
      showRejectPopup () {
        this.taskDecisionFlag = true
      },
      acceptTask () {
        this.$store.dispatch('getUserTaskDecision', true)
        this.taskDecisionFlag = this.$store.getters.getUserTaskDecision
      },
      showMetadataPopup (status) {
        this.model.form = {}
        this.model.errorMessage = {}
        for (var i = 0; i < this.model.dynamicUiData.length; i++) {
          if (this.model.dynamicUiData[i].isdefault) {
            this.model.form[this.model.dynamicUiData[i].key] = this.model.dynamicUiData[i].defaultvalue
          }
          this.model.errorMessage[this.model.dynamicUiData[i].key] = ''
        }
        this.model.status = status
        this.model.dynamicMetadataPopupFlag = true
      },
      hideMetadataPopup () {
        this.model.dynamicMetadataPopupFlag = false
      },
      submitMetadataPopup () {
        alert('submit')
      },
      completeButtonClick () {
        this.$router.push({name: 'New'})
        var langDropdown = document.querySelector('#langDropdown')
        if (langDropdown !== undefined && langDropdown !== null) {
          langDropdown.querySelector('select').disabled = true
        }
      },
      reject () {
        console.log('Notify for:' + this.$store.getters.getUserDetails)
        this.$store.commit(NOTIFY)
        var payload = { sessionid: this.$store.getters.getUserDetails, status: 'rejected', reason: this.rejectReason }
        console.log(this.rejectReason)
        this.$store.dispatch('notify', payload).then(function () {
          this.$router.push({name: 'Frozen'})
          this.$store.commit(NOTIFY_SUCCESS, {})
          this.taskDecisionFlag = false
        }.bind(this))
            .catch(function () {
              this.taskDecisionFlag = false
              this.$store.commit(ERROR_MSG, {
                type: 'error',
                title: this.$t('message.error_popup_page.error'),
                content: this.$t('message.error_popup_page.relaunch_msg')
              })
            }.bind(this))

       /* this.$dialog.confirm('Please provide reason for rejecting this task:')
        .then(function () {
          console.log('clicked')
          console.log(this)
        }.bind(this)) */
      }
    },
    components: {
      'dynamic-ui-form': DynamicUiForm
    }
  }
</script>



// WEBPACK FOOTER //
// Files.vue?5db6978e